export const CYCLE_CHANGE_REGEXP = /\d{1,2}:\d{2}\s*(?:am|AM)\s*[-|–]\s*\d{1,2}:\d{2}\s*(?:pm | PM)/

export const DEFAULT_TITLE = 'Review'

export const INNER_PROPS = {
  popoverLinkProps: { capitalize: true },
  popoverInnerContentProps: { capitalize: true }
}
